import * as React from "react";
import { throttle } from "throttle-debounce";
const useIsInViewport = (currentElement) => {
  const [isInViewport, setIsInViewport] = React.useState(false);
  const checkIsInViewport = () => {
    if (!currentElement.current) {
      setIsInViewport(false);
      return;
    }
    const { top, height: refHeight } = currentElement.current.getBoundingClientRect();
    setIsInViewport(top + refHeight >= 0 && top <= window.innerHeight);
  };
  React.useEffect(() => {
    checkIsInViewport();
    const throttledCheckIsInViewport = throttle(
      200,
      () => {
        checkIsInViewport();
      },
      { noTrailing: false }
    );
    window.addEventListener("scroll", throttledCheckIsInViewport);
    return () => window.removeEventListener("scroll", throttledCheckIsInViewport);
  }, []);
  if (typeof window === "undefined") {
    return false;
  }
  return isInViewport;
};
export {
  useIsInViewport as default
};
//# sourceMappingURL=useIsInViewport.js.map
